import { Input, Select } from "antd";
import React, { createRef, useState } from "react";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search } from "../../../../Controllers/Global";
import toast from "react-hot-toast";
import { DeleteOutlined } from "@ant-design/icons";
import Error from "../../../../Componets/Error";
import { get_product_unit } from "../../../../Controllers/Products/Units";
import Required from "../../../../Componets/Required";

const Inventoryunittable = React.forwardRef((props, focus) => {
  const { details, setDetails, form, setForm } = props;

  const handleChange = (e, index) => {
    if (e?.target?.value >= 0) {
      let data = [...details];

      data[index][e?.target?.name] = e?.target?.value;

      setDetails(data);

      if (e?.target?.name == "stock") {
        form[2].options[0].form.value =
          parseFloat(e?.target?.value || 0) /
          parseFloat(details?.[0]?.conversion || 0);
        setForm(form);
      }
    }
  };

  const handleAdd = () => {
    setDetails((prevDetails) => [
      ...prevDetails,
      {
        id: "",
        name: null,
        label: "",
        options: "",
        conversion: "",
      },
    ]);
  };

  const handleRemove = (index) => {
    let data = [...details];

    data?.splice(index, 1);

    setDetails(data);
  };

  const handleSearch = async (e, index) => {
    let data = [...details];

    const select = {
      api: "get-all-product-units",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({ value: value?._id, label: value?.name });
        // options?.push({ value: value?.name, label: value?.name });
      });

      data[index].options = options;

      setDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleConversion = (e, index) => {
    if (e?.target?.value >= 0) {
      let data = [...details];

      data[index][e?.target?.name] = e?.target?.value;

      setDetails(data);
    }
  };

  const handleName = async (e, index) => {
    let data = [...details];

    if (e) {
      let ids = [];

      data?.map((v, i) => {
        ids?.push(v?.name);
      });

      if (!ids?.includes(e)) {
        let params = {
          id: e,
        };

        const product_unit = await get_product_unit(params);

        // data[index].name = product_unit?.data?._id;
        data[index].name = product_unit?.data?.name;
        data[index].label = product_unit?.data?.name;
        setDetails(data);
      } else {
        data[index].name = null;
        data[index].label = "";
        setDetails(data);
        toast?.error("Unit exists");
      }
    } else {
      data[index].name = null;
      data[index].label = "";
      data[index].conversion = "";
      setDetails(data);
    }
  };

  return (
    <div>
      <table className="w-full">
        <thead>
          <tr>
            <td className="border p-4 text-black">
              Name
              <Required />
            </td>
            <td className="border p-4 text-black">
              Conversion <Required />
            </td>
            <td className="border p-4 text-black">
              Purchase price <Required />
            </td>
            <td className="border p-4 text-black">
              Price/unit <Required />
            </td>
            <td className="border p-4 text-black">
              Sale price <Required />
            </td>
            <td className="border p-4 text-black">Wholesale price</td>
            <td className="border p-4 text-black">
              Stock <Required />
            </td>
            <td className="border p-4 text-black">Delete</td>
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            // focus.current[`name${index}`] = createRef();
            // focus.current[`conversion${index}`] = createRef();
            return (
              <React.Fragment>
                <tr>
                  {/* <td className="border p-4 text-left">{value?.name}</td> */}
                  <td className="border p-4">
                    {value?.name ? (
                      <div>
                        <div> {value?.name}</div>
                        <Error id={`name${index}`} />
                      </div>
                    ) : (
                      <div>
                        <Select
                          key={index}
                          name="name"
                          // ref={focus.current[`name${index}`]}
                          className="w-[150px] text-regular"
                          placeholder="Name"
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          options={value?.options}
                          value={value?.name}
                          onSearch={(e) => handleSearch(e, index)}
                          onClick={(e) => handleSearch("", index)}
                          onChange={(e) => handleName(e, index)}
                          autoComplete="off"
                        />
                        <Error id={`name${index}`} />
                      </div>
                    )}
                  </td>
                  {/* <td className="border p-4">{value?.conversion}</td> */}
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="conversion"
                      // ref={focus.current[`conversion${index}`]}
                      type="number"
                      className="w-full text-regular"
                      placeholder="Conversion"
                      value={value?.conversion}
                      onChange={(e) => handleConversion(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <Error id={`conversion${index}`} />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="purchase_price"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Purchase price"
                      value={value?.purchase_price}
                      onChange={(e) => handleChange(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="price_per_unit"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Price/unit"
                      value={value?.price_per_unit}
                      onChange={(e) => handleChange(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="sale_price"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Sale price"
                      value={value?.sale_price}
                      onChange={(e) => handleChange(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="wholesale_price"
                      type="number"
                      className="w-full text-regular"
                      placeholder="WholeSale price"
                      value={value?.wholesale_price}
                      onChange={(e) => handleChange(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="stock"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Stock"
                      value={value?.stock}
                      onChange={(e) => handleChange(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <Error id={`stock${index}`} />
                  </td>
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => handleRemove(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
          {details?.length < 1 ? (
            <tr>
              <td className="border p-4" colSpan={8}>
                <div className="text-end">
                  <AddButton onClick={handleAdd} />
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}
        </tbody>
      </table>
    </div>
  );
});

export default Inventoryunittable;
